import { HOUR_IN_MILLISECONDS } from 'config';
import {
  BreakingScheduleDto,
  BreakingTestDto,
  PourBreakingScheduleDetailsDto,
  useGetBreakingScheduleQuery,
  useGetPourBreakingScheduleDetails,
  useListByBreakingScheduleIdQuery
} from 'providers/api';
import { UseQueryResult } from 'react-query';
import { QAQCReportPageParams } from './constants';

export type QAQCReportQueries = [
  UseQueryResult<BreakingScheduleDto>,
  UseQueryResult<PourBreakingScheduleDetailsDto>,
  UseQueryResult<BreakingTestDto[], unknown>,
];

const useQAQCReportQueries = (params: QAQCReportPageParams): QAQCReportQueries => {
  const breakingScheduleQuery = useGetBreakingScheduleQuery(params.breakingScheduleId ?? '', {
    staleTime: HOUR_IN_MILLISECONDS,
  });

  const pourId = breakingScheduleQuery.data?.pourId ?? params.pourId ?? '';

  const pourBreakingScheduleDetailsQuery = useGetPourBreakingScheduleDetails({ pourId }, {
    enabled: !!pourId,
  });

  const breakingTestsQuery = useListByBreakingScheduleIdQuery(params.breakingScheduleId as string, { staleTime: HOUR_IN_MILLISECONDS });

  return [breakingScheduleQuery, pourBreakingScheduleDetailsQuery, breakingTestsQuery];
};

export default useQAQCReportQueries;
